import React, { useEffect, useState } from 'react';
import { Icon, ShoppingIcon } from '@/components';
import { MessageType } from '@/layouts/shared';
import { fetchProductsByCodes } from '@/features/consults/chat/api';

interface ReplyQuoteProps {
  replyMessageInfo: any;
  variant: 'left' | 'right';
}

const variantStyle = {
  left: { background: '#F8F9F9', borderColor: '#106657' },
  right: { background: '#0B7D69', borderColor: '#FFFFFF' },
};

const ReplyQuote = ({ replyMessageInfo, variant }: ReplyQuoteProps) => {
  const [productImage, setProductImage] = useState<string | null>(null);

  const isProduct = replyMessageInfo?.type === MessageType.Product;
  const hasImages = replyMessageInfo?.images?.length > 0;

  useEffect(() => {
    if (!isProduct || !hasImages) return;
    fetchProductsByCodes({ product_code: replyMessageInfo.images[0] })
      .then((res) => {
        if (Array.isArray(res.data) && res.data[0]?.image) {
          setProductImage(res.data[0].image);
        }
      })
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [replyMessageInfo?.images?.[0], isProduct]);

  if (!replyMessageInfo) return null;

  const s = variantStyle[variant];
  const ownerName = replyMessageInfo.user_name || '';

  const handleClick = () => {
    const el = document.getElementById(`message-${replyMessageInfo.id}`);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      el.style.transition = 'background 0.3s';
      el.style.background = 'rgba(0,0,0,0.08)';
      setTimeout(() => {
        el.style.background = '';
      }, 1000);
    }
  };

  if (hasImages) {
    const thumbnail = isProduct ? productImage : replyMessageInfo.images[0];
    const countLabel = isProduct
      ? `${replyMessageInfo.images.length} sản phẩm`
      : `${replyMessageInfo.images.length} hình ảnh`;

    return (
      <div
        onClick={handleClick}
        style={{ background: s.background, borderLeft: `3px solid ${s.borderColor}` }}
        className="tw-mb-2 tw-px-2 tw-py-1 tw-flex tw-items-center tw-gap-2 tw-rounded-sm tw-cursor-pointer tw-overflow-hidden"
      >
        <div className="tw-flex-shrink-0 tw-h-8 tw-w-8">
          {isProduct && !thumbnail ? (
            <div className="tw-h-full tw-w-full tw-flex tw-items-center tw-justify-center tw-bg-black/10 tw-rounded-sm">
              <Icon className="tw-w-5 tw-h-5 tw-opacity-70" icon={<ShoppingIcon />} />
            </div>
          ) : (
            // eslint-disable-next-line @next/next/no-img-element
            <img src={thumbnail!} alt="" className="tw-h-full tw-w-full tw-object-cover tw-rounded-sm" />
          )}
        </div>
        <div className="tw-flex tw-flex-col tw-min-w-0 tw-py-1 tw-pr-2">
          <div className="tw-text-xs tw-font-semibold tw-leading-tight tw-truncate">{ownerName}</div>
          <div className="tw-text-[11px] tw-leading-tight tw-opacity-80 tw-truncate">{countLabel}</div>
        </div>
      </div>
    );
  }

  return (
    <div
      onClick={handleClick}
      style={{ background: s.background, borderLeft: `3px solid ${s.borderColor}` }}
      className="tw-mb-2 tw-px-2 tw-py-1 tw-rounded-sm tw-cursor-pointer"
    >
      <div className="tw-text-xs tw-font-semibold tw-leading-tight tw-truncate">{ownerName}</div>
      <div className="tw-text-[11px] tw-leading-tight tw-truncate">{replyMessageInfo.content}</div>
    </div>
  );
};

export default ReplyQuote;
